import { memo } from 'react';

import { booleanSelectOptions } from 'KnmPackage/MainModule/constants/booleanSelectOptions';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { Row } from 'UIPackage/FormModule/components/Row';

import styles from './ErknmOtherInfo.module.scss';

interface IErknmWithVideoProps {
  watchOnly: boolean;
}

export const ErknmWithVideo = memo(({ watchOnly }: IErknmWithVideoProps) => {
  return (
    <Row title="Отметка об использовании видеозаписи">
      <SelectInputField
        className={styles.SelectField}
        id="withVideo"
        name="withVideo"
        options={booleanSelectOptions}
        size="medium"
        isClearable={false}
        disabled={watchOnly}
      />
    </Row>
  );
});
